export const ROUTE_NAMES = {
  LIST: 'matching-list',
  SETTLE: 'settle',
  SEND_PAYMENT: 'send-payment'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'matching/list'
  },
  [ROUTE_NAMES.SETTLE]: {
    name: ROUTE_NAMES.SETTLE,
    path: 'matching/settle/:id'
  },
  [ROUTE_NAMES.SEND_PAYMENT]: {
    name: ROUTE_NAMES.SEND_PAYMENT,
    path: 'matching/send-payment'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.SETTLE].name,
    path: ROUTES[ROUTE_NAMES.SETTLE].path,
    component: (resolve) => require(['./views/settle'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.SEND_PAYMENT].name,
    path: ROUTES[ROUTE_NAMES.SEND_PAYMENT].path,
    component: (resolve) => require(['./views/send-payment'], resolve)
  }
]
